
import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData, deleteData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import Select from 'react-select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';

const WorkEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId]);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({});
    const [CustomerRateRelation, setCustomerRateRelation] = useState([]);

    useEffect(() => {
        fetchData('WorkApi', `/WorkData/${id}`, token)//, token
            .then((response) => {
                console.log('API response:', response);
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, [id, userId]);

    const submitData = async () => {
        // Update CreatedBy field
        setFormData((prevData) => ({
            ...prevData,
            CreatedBy: userId,
        }));

        // Fetch existing items for validation
        const existingItems = await fetchData('WorkApi', `/${companyId}`, token); //, token
        console.log('Existing Items:', existingItems);

        const existingItem = existingItems.response_data?.find(
            (item) => item.Name === formData.Name
        );

        // If no changes are made, skip the update
        if (
            existingItem &&
            existingItem.HSNCode === formData.HSNCode &&
            parseFloat(existingItem.GSTRate) === parseFloat(formData.GSTRate)
        ) {
            alert('No changes detected.');
            return;
        }

        // Validate mandatory fields
        if (!formData.Name) {
            alert('Name is required.');
            return;
        }

        // if (!formData.HSNCode) {
        //     alert('HSN Code is required.');
        //     return;
        // }

        // Update data
        try {
            const response = await updateData('WorkApi', id, formData, token); //, token
            console.log('Record updated successfully:', response);
            setSuccessMessage('Record updated successfully.');
            setTimeout(() => setSuccessMessage(''), 3000);
            history.push('/WorkIndex');
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    const [editIndex, setEditIndex] = useState(null);
    const [editedData, setEditedData] = useState({});

    const handleEditClick = (index) => {
        setEditIndex(index);
        setEditedData(CustomerRateRelation[index]);
    };

    const handleInputChange = (field, value) => {
        setEditedData({
            ...editedData,
            [field]: value,
        });
    };

    const handleSaveClick = (index) => {
        handleEditChange(index, editedData);
        setEditIndex(null);
    };

    const handleEditChange = (index, updatedData) => {

        const updatedSlabs = CustomerRateRelation.map((slab, idx) =>
            idx === index ? updatedData : slab
        );
        setCustomerRateRelation(updatedSlabs);
    };

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%' }}>

                <div className='w-full mb-2 flex'>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Work Edit</h6>
                    <Button
                        variant="contained"
                        onClick={submitData}
                        disabled={isLoading}
                        sx={{
                            textTransform: 'none',
                            maxHeight: '30px',
                            ml: 2,
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            borderRadius: '10px',
                            background: "green"
                        }}
                    >
                        {isLoading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            "Update"
                        )}
                    </Button>

                    <Button
                        component={Link}
                        to="/WorkIndex"
                        variant="contained"
                        color="error"
                        sx={{
                            textTransform: 'none',
                            maxHeight: '30px',
                            ml: 2,
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            borderRadius: '10px'
                        }}
                    >
                        Back to List
                    </Button>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                <div className="w-full flex flex-wrap">
                    <div className="w-full" style={{ padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                        <div className="w-full mb-3 flex" >

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Name<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Name}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Name"
                                    name='Name'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    HSN Code
                                    {/* <span className="text-red-500">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.HSNCode}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="HSN Code"
                                    name='HSNCode'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    GST Rate<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.GSTRate}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="GST Rate"
                                    name='GSTRate'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                        </div>

                    </div>

                </div>

            </div >
        </Fragment >
    );
};

export default WorkEdit;